'use client';

interface SalesSummaryProps {
  totalAmount: number | null | undefined;
  quantity: number | null | undefined;
  average: number | null | undefined;
  standardDeviation: number | null | undefined;
}

export function SalesSummary({ totalAmount, quantity, average, standardDeviation }: SalesSummaryProps) {
  // Safe conversion and formatting
  const formatCurrency = (value: number | null | undefined) => {
    const num = value ?? 0;
    return `R$ ${Number(num).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const formatNumber = (value: number | null | undefined) => {
    return String(value ?? 0);
  };

  const metrics = [
    {
      label: 'Total de Vendas',
      value: formatCurrency(totalAmount),
      icon: '💰',
    },
    {
      label: 'Quantidade',
      value: formatNumber(quantity),
      icon: '📦',
    },
    {
      label: 'Médio',
      value: formatCurrency(average),
      icon: '📊',
    },
    {
      label: 'Desvio Padrão',
      value: formatCurrency(standardDeviation),
      icon: '📈',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {metrics.map((metric) => (
        <div
          key={metric.label}
          className="rounded-lg p-6 border transition-all hover:border-blue-400/50 hover:shadow-lg hover:shadow-blue-400/20"
          style={{
            backgroundColor: 'var(--card-bg)',
            borderColor: 'var(--card-border-bright)',
            backdropFilter: 'blur(10px)',
            padding: '1em',
          }}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm text-slate-400 mb-1 font-medium">{metric.label}</p>
              <p className="text-2xl font-bold text-center md:text-left">{metric.value}</p>
            </div>
            <div className="text-4xl opacity-40 ml-4">{metric.icon}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
